module.exports = __webpack_public_path__ + "img/home-slider-2.0d00c76b.jpeg";